import FlagOutlined from "@mui/icons-material/FlagOutlined";
import FolderOutlined from "@mui/icons-material/FolderOutlined";
import LocalOfferOutlined from "@mui/icons-material/LocalOfferOutlined";

import Flx from "../../../../components/layout/Flx";
import Txt from "../../../../components/typography/Txt";
import { teal } from "../../../../theme/colors";

// The "Group by" pill chips shared by the Documents table and the Parsed /
// Extracted table. Active chips wear the brand teal toggle-chip recipe (same
// as the form toggle chips): teal-50 fill, teal-200 border, teal-700 label. Status leads (top-level grouping), then Category, then Type.
//
// Swapped in for the older teal `GroupToggleButton`; that component still exists
// if this needs to be reverted.

const ON = teal[700];
const ON_SOFT = teal[50];
const ON_LINE = teal[200];
const ON_HOVER = teal[100];
const LINE = "#e5e7eb";
const BG = "#f9fafb";
const INK3 = "#6b7280";
const INK4 = "#9ca3af";

const Chip = ({ icon: Icon, label, active, onClick, ghost }) => (
  <Flx
    ac
    g={0.75}
    onClick={onClick}
    role="button"
    aria-pressed={active}
    sx={{
      cursor: "pointer",
      borderRadius: "999px",
      border: "1px solid",
      // `ghost` = for dark surfaces (the bulk bar): the inactive state has no
      // fill so the chips read as outlines on the dark background instead of
      // solid white pills. Active stays the teal selected pill.
      borderColor: active ? ON_LINE : ghost ? "rgba(255,255,255,0.30)" : LINE,
      background: active ? ON_SOFT : ghost ? "transparent" : "#fff",
      color: active ? ON : ghost ? "#e2e8f0" : INK3,
      px: 1.25,
      py: 0.4,
      fontSize: 11.5,
      fontWeight: 600,
      whiteSpace: "nowrap",
      flexShrink: 0,
      transition: "all .12s",
      "&:hover": {
        background: active ? ON_HOVER : ghost ? "rgba(255,255,255,0.10)" : BG,
      },
    }}
  >
    <Icon sx={{ fontSize: 14 }} />
    {label}
  </Flx>
);

const GroupByChips = ({
  groupByStatus,
  groupByCategory,
  groupByType,
  onToggleStatus,
  onToggleCategory,
  onToggleType,
  showLabel = true,
  // Ghost styling for dark surfaces (e.g. the bulk-edit bar) — inactive chips
  // are transparent outlines rather than solid white pills.
  ghost = false,
  sx,
}) => (
  <Flx ac wrap g={0.75} sx={sx}>
    {showLabel && (
      <Txt
        sx={{ fontSize: 11.5, color: ghost ? "rgba(255,255,255,0.6)" : INK4 }}
      >
        Group by
      </Txt>
    )}
    <Chip
      icon={FlagOutlined}
      label="Status"
      active={groupByStatus}
      onClick={onToggleStatus}
      ghost={ghost}
    />
    <Chip
      icon={FolderOutlined}
      label="Category"
      active={groupByCategory}
      onClick={onToggleCategory}
      ghost={ghost}
    />
    <Chip
      icon={LocalOfferOutlined}
      label="Type"
      active={groupByType}
      onClick={onToggleType}
      ghost={ghost}
    />
  </Flx>
);

export default GroupByChips;
export { GroupByChips };
